import React, { useState, useEffect } from "react";
import * as Mui from "@mui/material";
import {
  House,
  ImportantDevices,
  Smartphone,
  PersonOff,
  Fingerprint,
  ShareLocation,
} from "@mui/icons-material";
import { themes } from "services/constants";
import { getStatusColor } from "services/utils/Status";
import { Loader } from "components/Loader";
import { tooltipStyleProps } from "services/constants/Styles";
import EditIcon from "@mui/icons-material/Edit";
import { EditCheckInOut } from "./EditCheckInOut";
import { sideBarIcon, adminRoleName } from "services/constants";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";

export const CardView = ({
  loading,
  filterDepartMemberList,
  expand,
  setExpand,
  page,
  setPage,
  masterDataForSearch,
  setShiftDetails,
  setUserId,
  setGetUser,
  setOpenSidePeek,
  openSidePeek,
  shiftDetails,
  fetchStatus,
  departmentId,
}) => {
  const [onClickCard, setOnClickCard] = useState({});
  const [showIcons, setShowIcons] = useState(true);
  const [editState, setEditState] = useState(false);
  const [intervalTime, setIntervalTime] = useState(200);
  const [rowsPerPage, setLeaveRowsPerPage] = useState(25);
  const { userDetails: currentUserDetails, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  let expandCardData = true;
  let access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Attendance",
    "Status"
  );

  useEffect(() => {
    if (expand) {
      setOnClickCard(0);
      setExpand(false);
    }
  }, [expand, setExpand]);

  useEffect(() => {
    const recallApi = () => {
      setEditState(false);
      fetchStatus(true);
    };
    if (editState && !openSidePeek) {
      recallApi();
    }
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setShowIcons(!showIcons);
      setIntervalTime(200);
    }, intervalTime);
    return () => {
      clearInterval(interval);
    };
  }, [intervalTime, showIcons]);

  const handleChangeLeaveRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setLeaveRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleChangeLeavePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleCardClick = (cardId) => {
    if (expandCardData) {
      setOnClickCard((prevState) => ({
        [cardId]: !prevState[cardId],
      }));
    } else {
      setOnClickCard(0);
    }
  };

  const statusBasedIcons = (status, locationStatus) => {
    switch (status) {
      case "Home":
        return (
          <Mui.Tooltip arrow slotProps={tooltipStyleProps} title="Home">
            <Mui.IconButton
              onMouseOver={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(100000000);
                  setShowIcons(false);
                }
              }}
              onMouseOut={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(2000);
                }
              }}
            >
              <House
                style={{
                  fontSize: "large",
                  color:
                    locationStatus === "Pending" || locationStatus === "Hold"
                      ? "red"
                      : themes.activeTap,
                }}
              />
            </Mui.IconButton>
          </Mui.Tooltip>
        );
      case "Office":
        return (
          <Mui.Tooltip arrow slotProps={tooltipStyleProps} title="Office">
            <Mui.IconButton
              onMouseOver={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(100000000);
                  setShowIcons(false);
                }
              }}
              onMouseOut={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(2000);
                }
              }}
            >
              <ImportantDevices
                style={{
                  fontSize: "large",
                  color:
                    locationStatus === "Pending" || locationStatus === "Hold"
                      ? "red"
                      : themes.activeTap,
                }}
              />
            </Mui.IconButton>
          </Mui.Tooltip>
        );
      case "Site":
        return (
          <Mui.Tooltip arrow slotProps={tooltipStyleProps} title="Site">
            <Mui.IconButton
              onMouseOver={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(100000000);
                  setShowIcons(false);
                }
              }}
              onMouseOut={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(2000);
                }
              }}
            >
              <Smartphone
                style={{
                  fontSize: "large",
                  color:
                    locationStatus === "Pending" || locationStatus === "Hold"
                      ? "red"
                      : themes.activeTap,
                }}
              />
            </Mui.IconButton>
          </Mui.Tooltip>
        );
      case "Biometric":
        return (
          <Mui.Tooltip arrow slotProps={tooltipStyleProps} title="Biometric">
            <Mui.IconButton
              onMouseOver={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(100000000);
                  setShowIcons(false);
                }
              }}
              onMouseOut={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(2000);
                }
              }}
            >
              <Fingerprint
                style={{
                  fontSize: "large",
                  color:
                    locationStatus === "Pending" || locationStatus === "Hold"
                      ? "red"
                      : themes.activeTap,
                }}
              />
            </Mui.IconButton>
          </Mui.Tooltip>
        );
      case "Tracking":
        return (
          <Mui.Tooltip arrow slotProps={tooltipStyleProps} title="Tracking">
            <Mui.IconButton
              onMouseOver={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(100000000);
                  setShowIcons(false);
                }
              }}
              onMouseOut={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(2000);
                }
              }}
            >
              <ShareLocation
                style={{
                  fontSize: "large",
                  color:
                    locationStatus === "Pending" || locationStatus === "Hold"
                      ? "red"
                      : themes.activeTap,
                }}
              />
            </Mui.IconButton>
          </Mui.Tooltip>
        );
      case "None":
        return (
          <Mui.Tooltip arrow slotProps={tooltipStyleProps} title="-">
            <Mui.IconButton
              onMouseOver={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(100000000);
                  setShowIcons(false);
                }
              }}
              onMouseOut={() => {
                if (locationStatus === "Pending" || locationStatus === "Hold") {
                  setIntervalTime(2000);
                }
              }}
            >
              <PersonOff
                style={{
                  fontSize: "large",
                  color: "red",
                }}
              />
            </Mui.IconButton>
          </Mui.Tooltip>
        );
      default:
        return "";
    }
  };

  return (
    <React.Fragment>
      <Mui.Grid container spacing={0} sx={{ justifyContent: "center" }}>
        {loading ? (
          <Loader info="Loading..." />
        ) : filterDepartMemberList?.length === 0 ? (
          <Mui.Grid xs={11.5} sx={{ mt: 5 }}>
            <Mui.Alert severity="info">
              {masterDataForSearch?.length === 0 && !loading
                ? "No data available."
                : "No matching data found for your search."}
            </Mui.Alert>
          </Mui.Grid>
        ) : (
          filterDepartMemberList
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((item) => (
              <Mui.Grid item key={item.id}>
                <Mui.Card
                  className=" min-h-full max-w-fit mt-5 w-96 flex space-x-1 shadow-lg "
                  variant="outlined"
                  sx={{
                    borderRadius: 2,
                    marginLeft: 5,
                    backgroundColor:
                      item.current_location_status === "Pending" ||
                      item.current_location_status === "Hold"
                        ? themes.backgroundShadow
                        : themes.whiteColor,
                  }}
                  onClick={() => handleCardClick(item.id)}
                >
                  <Mui.CardContent>
                    <Mui.Grid container>
                      <Mui.Grid item xs={2.5}>
                        <Mui.Avatar
                          sx={{
                            width: 40,
                            height: 40,
                          }}
                          alt={item.user_name?.charAt(0).toUpperCase()}
                          src={item.image_url}
                        />
                      </Mui.Grid>
                      <Mui.Grid
                        item
                        xs={9.5}
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                        }}
                      >
                        <Mui.Stack>
                          <Mui.Tooltip
                            arrow
                            slotProps={tooltipStyleProps}
                            title={item.user_name}
                          >
                            <Mui.Grid container>
                              <Mui.Typography
                                fontWeight={"bold"}
                                sx={{
                                  fontSize:
                                    item.user_name.length < 10
                                      ? "18px"
                                      : "15px",
                                }}
                              >
                                {item.user_name
                                  ? item.user_name.length >= 10
                                    ? item.user_name.substr(0, 10) + "..."
                                    : item.user_name
                                  : "N/A"}{" "}
                              </Mui.Typography>
                            </Mui.Grid>
                          </Mui.Tooltip>
                          <Mui.Grid container>
                            <Mui.Grid
                              item
                              xs={item.type === "Week Off" ? 9.5 : 10}
                            >
                              <Mui.Typography>
                                {item?.user_code
                                  ? item.user_code.toString().padStart(6, "0")
                                  : "N/A"}
                              </Mui.Typography>
                            </Mui.Grid>
                            <Mui.Grid
                              item
                              xs={item.type === "Week Off" ? 2.5 : 2}
                            >
                              <Mui.Grid item sx={{ mt: -5.5, ml: 7 }}>
                                <Mui.Tooltip
                                  arrow
                                  slotProps={tooltipStyleProps}
                                  title={"Edit Attendance"}
                                >
                                  <Mui.IconButton
                                    onClick={() => {
                                      if (access) {
                                        if (
                                          (item.shift_name !== "Unassigned" &&
                                            item?.user_id !==
                                              currentUserDetails?.id) ||
                                          (currentUserDetails?.type ===
                                            adminRoleName &&
                                            item.shift_name !== "Unassigned")
                                        ) {
                                          setShiftDetails({
                                            ...item,
                                            shift_filter_date: item.date
                                              .split("-")
                                              .reverse()
                                              .join("-"),
                                          });
                                          setUserId(item?.user_id);
                                          setGetUser(true);
                                          setOpenSidePeek(true);
                                          expandCardData = false;
                                        } else {
                                          if (
                                            item?.user_id ===
                                            currentUserDetails?.id
                                          ) {
                                            expandCardData = false;
                                            showToast(
                                              "error",
                                              "Your data cannot be edited by yourself"
                                            );
                                          } else {
                                            expandCardData = false;
                                            showToast(
                                              "error",
                                              "Unassigned shifts cannot be edited"
                                            );
                                          }
                                        }
                                      } else {
                                        expandCardData = false;
                                        showToast(
                                          "error",
                                          "Access denied: You are not authorized to modify this data"
                                        );
                                      }
                                    }}
                                  >
                                    <EditIcon
                                      sx={{
                                        ...sideBarIcon,
                                        color: themes.greenColor,
                                        stroke: themes.greenColor,
                                        fontSize: 20,
                                      }}
                                    />
                                  </Mui.IconButton>
                                </Mui.Tooltip>
                              </Mui.Grid>
                              <Mui.Tooltip
                                arrow
                                slotProps={tooltipStyleProps}
                                title={
                                  item.type === "Missing"
                                    ? item.reason || ""
                                    : ""
                                }
                                disableHoverListener={item.type !== "Missing"}
                              >
                                <Mui.Box
                                  name="status"
                                  sx={{
                                    width: item.type === "Week Off" ? 90 : 80,
                                    height: 15,
                                    backgroundColor: getStatusColor(item.type),
                                    borderRadius: "16px",
                                    border:
                                      item.type === "Week Off"
                                        ? "1px solid black"
                                        : "none",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color:
                                      item.type === "Week Off"
                                        ? themes?.headLine
                                        : themes.whiteColor,
                                    p: 2,
                                    fontSize: 13,
                                    cursor:
                                      item.type === "Missing"
                                        ? "pointer"
                                        : "default",
                                  }}
                                >
                                  {item.type}
                                </Mui.Box>
                              </Mui.Tooltip>
                            </Mui.Grid>
                          </Mui.Grid>
                        </Mui.Stack>
                      </Mui.Grid>
                      <Mui.Grid item xs={3}></Mui.Grid>
                      <Mui.Grid item xs={0.5}></Mui.Grid>
                    </Mui.Grid>
                    <div className="mt-2 ">
                      <Mui.Grid item xs={6} sx={{ marginTop: 1 }}>
                        <Mui.Typography
                          sx={{ color: themes.primaryIndicator }}
                          fontSize={18}
                        >
                          Check-In
                        </Mui.Typography>
                      </Mui.Grid>
                      <Mui.Grid
                        item
                        xs={6}
                        sx={{ marginTop: -3.5, marginLeft: 20 }}
                      >
                        <Mui.Typography
                          sx={{ color: themes.primaryIndicator }}
                          fontSize={18}
                        >
                          Check-Out
                        </Mui.Typography>
                      </Mui.Grid>
                      <Mui.Grid container spacing={2}>
                        <Mui.Grid item xs={6}>
                          <Mui.Typography sx={{ mt: 0, ml: 0 }} fontSize={16}>
                            {item?.check_in_time_formatted
                              ? item?.check_in_time_formatted
                              : "N/A"}
                          </Mui.Typography>
                        </Mui.Grid>
                        <Mui.Grid item xs={6}>
                          <Mui.Typography sx={{ mt: 0, ml: 4 }} fontSize={16}>
                            {item?.check_out_time_formatted
                              ? item?.check_out_time_formatted
                              : "N/A"}
                          </Mui.Typography>
                        </Mui.Grid>
                      </Mui.Grid>
                    </div>
                    {onClickCard[item.id] && (
                      <>
                        {item?.ot_allowed && (
                          <Mui.Grid>
                            <Mui.Stack direction="row">
                              <Mui.Grid container>
                                <Mui.Grid
                                  item
                                  xs={4}
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-start",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Mui.Typography
                                    sx={{ color: themes.primaryIndicator }}
                                    fontSize={15}
                                  >
                                    Ot Start
                                  </Mui.Typography>
                                </Mui.Grid>
                                <Mui.Grid
                                  item
                                  xs={4}
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-center",
                                    alignItems: "flex-center",
                                    paddingLeft: 0.5,
                                  }}
                                >
                                  <Mui.Typography
                                    sx={{ color: themes.primaryIndicator }}
                                    fontSize={15}
                                  >
                                    Ot End
                                  </Mui.Typography>
                                </Mui.Grid>
                                <Mui.Grid
                                  item
                                  xs={4}
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end",
                                  }}
                                >
                                  <Mui.Typography
                                    sx={{ color: themes.primaryIndicator }}
                                    fontSize={15}
                                  >
                                    Total-Time
                                  </Mui.Typography>
                                </Mui.Grid>
                              </Mui.Grid>
                            </Mui.Stack>
                            {item.overtime_details.length === 0 ? (
                              <Mui.Stack
                                direction="row"
                                spacing={2}
                                sx={{ paddingLeft: 0 }}
                              >
                                <Mui.Grid item xs={4}>
                                  <Mui.Typography fontSize={15}>
                                    N/A
                                  </Mui.Typography>
                                </Mui.Grid>
                                <Mui.Grid item xs={4}>
                                  <Mui.Typography fontSize={15}>
                                    N/A
                                  </Mui.Typography>
                                </Mui.Grid>
                                <Mui.Grid item xs={4}>
                                  <Mui.Typography fontSize={15}>
                                    N/A
                                  </Mui.Typography>
                                </Mui.Grid>
                              </Mui.Stack>
                            ) : (
                              item.overtime_details.map(
                                (breakDetail, index) => (
                                  <Mui.Stack
                                    direction="row"
                                    spacing={2}
                                    sx={{ paddingLeft: 0 }}
                                  >
                                    <Mui.Grid item xs={4}>
                                      <Mui.Typography sx={{ fontSize: 14 }}>
                                        {breakDetail?.ot_start_formatted
                                          ? breakDetail?.ot_start_formatted
                                          : "N/A"}
                                      </Mui.Typography>
                                    </Mui.Grid>
                                    <Mui.Grid item xs={4}>
                                      <Mui.Typography sx={{ fontSize: 14 }}>
                                        {breakDetail?.ot_end_formatted
                                          ? breakDetail?.ot_end_formatted
                                          : "N/A"}
                                      </Mui.Typography>
                                    </Mui.Grid>
                                    <Mui.Grid item xs={4}>
                                      <Mui.Typography sx={{ fontSize: 14 }}>
                                        {breakDetail.individual_ot_time &&
                                        breakDetail.individual_ot_time !==
                                          "null"
                                          ? breakDetail.individual_ot_time
                                          : "N/A"}
                                      </Mui.Typography>
                                    </Mui.Grid>
                                  </Mui.Stack>
                                )
                              )
                            )}
                          </Mui.Grid>
                        )}
                        <Mui.Stack direction="row">
                          <Mui.Grid container>
                            <Mui.Grid
                              item
                              xs={4}
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                              }}
                            >
                              <Mui.Typography
                                sx={{ color: themes.primaryIndicator }}
                                fontSize={15}
                              >
                                Break Start
                              </Mui.Typography>
                            </Mui.Grid>
                            <Mui.Grid
                              item
                              xs={4}
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-center",
                                alignItems: "flex-center",
                                paddingLeft: 0.5,
                              }}
                            >
                              <Mui.Typography
                                sx={{ color: themes.primaryIndicator }}
                                fontSize={15}
                              >
                                Break End
                              </Mui.Typography>
                            </Mui.Grid>
                            <Mui.Grid
                              item
                              xs={4}
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-end",
                                alignItems: "flex-end",
                              }}
                            >
                              <Mui.Typography
                                sx={{ color: themes.primaryIndicator }}
                                fontSize={15}
                              >
                                Total-Time
                              </Mui.Typography>
                            </Mui.Grid>
                          </Mui.Grid>
                        </Mui.Stack>
                        {item.break_details.length === 0 ? (
                          <Mui.Stack
                            direction="row"
                            spacing={2}
                            sx={{ paddingLeft: 0 }}
                          >
                            <Mui.Grid item xs={4}>
                              <Mui.Typography fontSize={15}>N/A</Mui.Typography>
                            </Mui.Grid>
                            <Mui.Grid item xs={4}>
                              <Mui.Typography fontSize={15}>N/A</Mui.Typography>
                            </Mui.Grid>
                            <Mui.Grid item xs={4}>
                              <Mui.Typography fontSize={15}>N/A</Mui.Typography>
                            </Mui.Grid>
                          </Mui.Stack>
                        ) : (
                          item.break_details.map((breakDetail, index) => (
                            <Mui.Stack
                              direction="row"
                              spacing={2}
                              sx={{ paddingLeft: 0 }}
                            >
                              <Mui.Grid item xs={4}>
                                <Mui.Typography sx={{ fontSize: 14 }}>
                                  {breakDetail?.break_out_formatted
                                    ? breakDetail?.break_out_formatted
                                    : "N/A"}
                                </Mui.Typography>
                              </Mui.Grid>
                              <Mui.Grid item xs={4}>
                                <Mui.Typography sx={{ fontSize: 14 }}>
                                  {breakDetail?.break_in_formatted
                                    ? breakDetail?.break_in_formatted
                                    : "N/A"}
                                </Mui.Typography>
                              </Mui.Grid>
                              <Mui.Grid item xs={4}>
                                <Mui.Typography sx={{ fontSize: 14 }}>
                                  {breakDetail.individual_break_time &&
                                  breakDetail.individual_break_time !== "null"
                                    ? breakDetail.individual_break_time
                                    : "N/A"}
                                </Mui.Typography>
                              </Mui.Grid>
                            </Mui.Stack>
                          ))
                        )}

                        <Mui.Stack direction="row" sx={{ paddingTop: 1 }}>
                          <Mui.Grid xs={9}>
                            <Mui.Typography
                              sx={{ color: themes.primaryIndicator }}
                              fontSize={17}
                            >
                              Total Break Hours
                            </Mui.Typography>
                          </Mui.Grid>
                          <Mui.Grid xs={1}>:</Mui.Grid>
                          <Mui.Grid xs={2}>
                            <Mui.Typography>
                              {item?.total_break_time
                                ? item?.total_break_time
                                : "N/A"}
                            </Mui.Typography>
                          </Mui.Grid>
                        </Mui.Stack>
                      </>
                    )}
                    <Mui.Stack direction="row" sx={{ paddingTop: 0.5 }}>
                      <Mui.Grid xs={9}>
                        <Mui.Typography
                          sx={{ color: themes.primaryIndicator }}
                          fontSize={17}
                        >
                          Total OverTime Hours
                        </Mui.Typography>
                      </Mui.Grid>
                      <Mui.Grid xs={1}>:</Mui.Grid>
                      <Mui.Grid xs={2}>
                        <Mui.Typography>
                          {item?.total_over_time
                            ? item?.total_over_time
                            : "N/A"}
                        </Mui.Typography>
                      </Mui.Grid>
                    </Mui.Stack>
                    <Mui.Stack direction="row" sx={{ paddingTop: 0.5 }}>
                      <Mui.Grid xs={9}>
                        <Mui.Typography
                          sx={{ color: themes.primaryIndicator }}
                          fontSize={17}
                        >
                          Total Working Hours
                        </Mui.Typography>
                      </Mui.Grid>
                      <Mui.Grid xs={1}>:</Mui.Grid>
                      <Mui.Grid xs={2}>
                        <Mui.Typography>
                          {item?.total_work_time
                            ? item?.total_work_time
                            : "N/A"}
                        </Mui.Typography>
                      </Mui.Grid>
                    </Mui.Stack>
                    <div style={{ paddingTop: 15 }}>
                      <Mui.Grid container>
                        <Mui.Grid item xs={6}>
                          <Mui.Typography
                            fontSize={15}
                            fontWeight={"bold"}
                            sx={{
                              paddingBottom: 1.5,
                              color: themes.primaryIndicator,
                            }}
                          >
                            Shift Name
                          </Mui.Typography>
                          <Mui.Tooltip
                            arrow
                            slotProps={tooltipStyleProps}
                            title={item.shift_name}
                          >
                            <Mui.Typography>
                              {item.shift_name
                                ? item.shift_name.length >= 12
                                  ? item.shift_name.substr(0, 12) + "..."
                                  : item.shift_name
                                : "N/A"}
                            </Mui.Typography>
                          </Mui.Tooltip>
                        </Mui.Grid>
                        <Mui.Grid
                          item
                          xs={6}
                          sx={{ marginTop: 0, justifyContent: "flex-end" }}
                        >
                          <div
                            style={{
                              justifyContent: "flex-end",
                              display:
                                item.current_location_status === "Pending" ||
                                item.current_location_status === "Hold"
                                  ? showIcons
                                    ? "none"
                                    : "flex"
                                  : "flex",
                            }}
                          >
                            {statusBasedIcons(
                              item.current_location_tag,
                              item.current_location_status
                            )}
                          </div>

                          {item.current_location_name === "-" ? (
                            <Mui.Tooltip
                              arrow
                              slotProps={tooltipStyleProps}
                              title={item.current_location_name}
                            >
                              <Mui.Typography
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "flex-end",
                                  alignItems: "flex-end",
                                  paddingRight: 2,
                                  fontSize: 15,
                                }}
                              >
                                {item.current_location_name
                                  ? item.current_location_name.length >= 10
                                    ? item.current_location_name.substr(0, 10) +
                                      "..."
                                    : item.current_location_name
                                  : "N/A"}
                              </Mui.Typography>
                            </Mui.Tooltip>
                          ) : (
                            <Mui.Tooltip
                              arrow
                              slotProps={tooltipStyleProps}
                              title={item.current_location_name}
                            >
                              <Mui.Typography
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "flex-end",
                                  alignItems: "flex-end",
                                  fontSize: 15,
                                }}
                              >
                                {item.current_location_name
                                  ? item.current_location_name.length >= 10
                                    ? item.current_location_name.substr(0, 10) +
                                      "..."
                                    : item.current_location_name
                                  : "N/A"}
                              </Mui.Typography>
                            </Mui.Tooltip>
                          )}
                        </Mui.Grid>
                      </Mui.Grid>
                    </div>
                  </Mui.CardContent>
                </Mui.Card>
              </Mui.Grid>
            ))
        )}
      </Mui.Grid>
      {filterDepartMemberList.length > 25 && (
        <Mui.TablePagination
          className="custom-pagination"
          rowsPerPageOptions={[25, 50, 75, 100]}
          component="div"
          count={filterDepartMemberList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangeLeavePage}
          onRowsPerPageChange={handleChangeLeaveRowsPerPage}
        />
      )}

      {openSidePeek ? (
        <EditCheckInOut
          setOpenSidePeek={setOpenSidePeek}
          openSidePeek={openSidePeek}
          shiftDetails={shiftDetails}
          setEditState={setEditState}
          departmentId={departmentId}
        />
      ) : null}
    </React.Fragment>
  );
};
